module.exports = __webpack_public_path__ + "static/media/ios-rose.50f82eba.svg";